import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  LineController,
  BarController,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

let chartRegistered = false;

/** Register Chart.js controllers/scales used by StockFundamentalsDashboard. */
export function ensureFundamentalsChartsRegistered() {
  if (chartRegistered) return;
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    LineController,
    BarController,
    Tooltip,
    Legend,
    Filler,
  );
  chartRegistered = true;
}
